import { isNull, isUndefined } from 'lodash';
import endpoints from '../utils/apiEndpoints';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class ContactService extends AbstractService {
	static setup(baseURL, options) {
		instance = new ContactService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoint = endpoints.contacts;
	}

	static getAll(...params) {
		if (isNull(instance)) return Promise.reject_(_SERVICE_UNAVAILABLE_);

		return instance._getAll(...params);
	}

	static getContactsByClientId(...params) {
		if (isNull(instance)) return Promise.reject_(_SERVICE_UNAVAILABLE_);

		return instance._getContactsByClientId(...params);
	}

	static save(...params) {
		if (isNull(instance)) return Promise.reject_(_SERVICE_UNAVAILABLE_);

		return instance._save(...params);
	}

	static delete(...params) {
		if (isNull(instance)) return Promise.reject_(_SERVICE_UNAVAILABLE_);

		return instance._delete(...params);
	}

	static mergeContact(...params) {
		if (isNull(instance)) return Promise.reject_(_SERVICE_UNAVAILABLE_);

		return instance._mergeContact(...params);
	}

	static deleteClientContact(...params) {
		if (isNull(instance)) return Promise.reject_(_SERVICE_UNAVAILABLE_);

		return instance._deleteClientContact(...params);
	}

	_getAll({
		pageNumber,
		displayCount,
		search,
		includeAll,
		minimalData,
		clientId,
		organizationId,
	}) {
		const endpoint = `${organizationId ? endpoints.organizations : endpoints.clients}/${organizationId || clientId}/${this.endpoint}`;
		return this.get({
			endpoint,
			queryParams : {
				pageNumber,
				displayCount,
				search,
				includeAll,
				minimalData,
			},
		});
	}

	_getContactsByClientId(clientId, queryParams) {
		return this.get({
			endpoint : `${endpoints.clients}/${clientId}/${this.endpoint}`,
			queryParams,
		});
	}

	_save({
		id,
		firstName,
		lastName,
		city,
		state,
		zipCode,
		isAdmin,
		clientId,
		organizationId,
		address : streetAddress1,
		phone : mobilePhone,
		email : emailAddress,
	}) {
		const isCreating = isUndefined(id);
		const endpoint = isCreating
			? `${organizationId ? endpoints.organizations : endpoints.clients}/${organizationId || clientId}/${this.endpoint}`
			: `${this.endpoint}/${id}`;

		return this.request({
			endpoint,
			method : isCreating ? 'POST' : 'PUT',
			data   : {
				firstName,
				lastName,
				emailAddress,
				mobilePhone,
				streetAddress1,
				city,
				zipCode,
				isAdmin,
				organizationId,
				stateId : state || undefined,
			},
		});
	}

	_delete(id) {
		return this.del({
			endpoint : `${this.endpoint}/${id}`,
		});
	}

	_mergeContact({
		id,
		clientId,
		organizationId,
	}) {
		return this.put({
			endpoint : `${organizationId ? endpoints.organizations : endpoints.clients}/${organizationId || clientId}/${this.endpoint}`,
			data     : { id },
		});
	}

	_deleteClientContact(clientId, contactId) {
		return this.del({
			endpoint : `${endpoints.clients}/${clientId}/${this.endpoint}/${contactId}`,
		});
	}
}
